import { render } from "./AudienceHistoricSkeleton.vue?vue&type=template&id=18ffb7cb"
import script from "./AudienceHistoricSkeleton.vue?vue&type=script&lang=js"
export * from "./AudienceHistoricSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__